import { render, staticRenderFns } from "./portal-membresia-gestion.vue?vue&type=template&id=1e96279f&scoped=true&"
import script from "./portal-membresia-gestion.vue?vue&type=script&lang=js&"
export * from "./portal-membresia-gestion.vue?vue&type=script&lang=js&"
import style0 from "./portal-membresia-gestion.vue?vue&type=style&index=0&id=1e96279f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96279f",
  null
  
)

export default component.exports